import axios from 'axios';
import { baseUrl } from '@/config';

export default {
  /**
   * [장비등록 > 서버 > 자동화 모델링] 자동화 모델링 범위 목록 조회
   * @author jeee12
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getAmsModelingRangeList(params) {
    return axios.post(`${baseUrl}/settings/device-registration-ams/get-ams-modeling-range-list.do`, params);
  },
  /**
   * [장비등록 > 서버 > 자동화 모델링] 자동화 모델링 범위 추가 또는 수정
   * @author jeee12
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  insertAmsModelingRange(params) {
    return axios.post(`${baseUrl}/settings/device-registration-ams/insert-ams-modeling-range.do`, params);
  },
  /**
   * [장비등록 > 서버 > 자동화 모델링] 자동화 모델링 범위 삭제
   * @author jeee12
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  deleteAmsModelingRangeList(params) {
    return axios.post(`${baseUrl}/settings/device-registration-ams/delete-ams-modeling-range-list.do`, params);
  },
  /**
   * [장비등록 > 서버 > 자동화 모델링] 자동화 모델링 결과 조회
   * @author jeee12
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getAmsModelingResultList(params) {
    return axios.post(`${baseUrl}/settings/device-registration-ams/get-ams-modeling-result-list.do`, params);
  },
  /**
   * [장비등록 > 서버 > 자동화 모델링] 자동화 모델링 수행
   * @author jeee12
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  executeAmsModeling(params) {
    return axios.post(`${baseUrl}/settings/device-registration-ams/execute-ams-modeling.do`, params);
  },
  /**
   * [장비등록 > 서버 > 자동화 모델링] 자동화 모델링 수행 진행률 조회
   * @author jeee12
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getAmsModelingProgressRate(params) {
    return axios.post(`${baseUrl}/settings/device-registration-ams/get-ams-modeling-progress-rate.do`, params);
  },
};



// WEBPACK FOOTER //
// ./src/api/settings/common/device-registration-ams.js